export function FileChangeDot({ removed }: { removed: boolean }) {
  return (
    <span
      style={{
        display: "inline-block",
        width: 6,
        height: 6,
        marginLeft: 6,
        borderRadius: "50%",
        verticalAlign: "middle",
        background: removed ? "var(--red-600)" : "var(--green-600)",
      }}
    />
  );
}
